<template>
  <div class="contaier">
    <LayoutHeader />
    <LayoutCarousel v-if="ifShowCarousel" />
    <router-view :key="key" />
    <LayoutBottom />
  </div>
</template>

<script>
import LayoutHeader from './LayoutHeader.vue'
import LayoutCarousel from './LayoutCarousel.vue'
import LayoutBottom from './LayoutBottom.vue'
export default {
  name: 'LayoutIndex',
  components: {
    LayoutHeader,
    LayoutCarousel,
    LayoutBottom
  },
  computed: {
    key () {
      return this.$route.path
    },
    ifShowCarousel () {
      return !(this.$route.path.includes('news') || this.$route.path.includes('lessonDetail') || this.$route.path.includes('lesson'))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contaier{
    width: 100%;
    height: auto;
    min-height: 768px;
  }
</style>
